export default "__VITE_ASSET__Drjk0n2A__"